import React from 'react';
import { useNavigate } from 'react-router-dom';
import { popularCities } from '../data/popularCities';

export const PopularLocations: React.FC = () => {
  const navigate = useNavigate();

  const handleCityClick = (state: string, city: string) => {
    const citySlug = city.toLowerCase().replace(/\s+/g, '-');
    navigate(`/cities/${citySlug}`);
  };

  return (
    <div className="w-screen bg-black -mt-6" style={{ marginLeft: 'calc(-50vw + 50%)', marginRight: 'calc(-50vw + 50%)', width: '100vw' }}>
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-2xl font-bold text-white mb-6 text-center flex items-center justify-center gap-2">
          <span>Popular Locations</span>
          <img 
            src="https://cdn-icons-png.flaticon.com/512/661/661740.png"
            alt="Chinese Food icon"
            className="w-7 h-7"
          />
        </h2>
        <div className="grid grid-cols-5 gap-4 text-center">
          {popularCities.map((city) => (
            <button
              key={city.slug}
              onClick={() => handleCityClick(city.state, city.name)}
              className="text-white hover:text-gray-300 transition-colors text-lg"
            >
              {city.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};